
function CalculateCombinePrice() {

    var CombineSubTotal = 0;
    var FreeCargoLimit = parseFloat($("#FreeCargoLimit").val().replace(",", "."));

    $(".CombineColors input.SizeID").each(function (index) {

        if ($(this).closest(".CombineColors").next().find("a.SizeLink.active").length > 0) {

            var CombineItemPriceAmount = parseFloat($(this).closest(".CombineItemRow").find(".CombineItemAmount").attr("data-amount").replace(",", "."));
            CombineSubTotal += CombineItemPriceAmount;
        }

    });

    $(".CombineSelectedPrice").html(CombineSubTotal.toFixed(2));

    if (CombineSubTotal >= FreeCargoLimit) {
        $(".BottomFreeCargoInfo").slideDown("slow");
    }
    else {
        $(".BottomFreeCargoInfo").slideUp("slow");
    }
}

function RunSlickSlider() {
    if ($('.ProductDetailImages ul li').length > 0) {

        $(".VideoArea").closest("li").remove();
        $(".DownloadImage").remove();

        $('.ProductDetailImages ul li img').each(function () {
            if ($(this).attr("data-src") != undefined && $(this).attr("data-src") != "") {
                $(this).attr("src", $(this).attr("data-src"));
            }
        });

        $slc = $('.ProductDetailImages ul').slick({
            centerMode: false,
            prevArrow: "<img class='solOk' src='/Images/OXB2B/left.png'/>",
            nextArrow: "<img class='sagOk' src='/Images/OXB2B/right.png'/>",
        });


        $miniImage.slick({
            slidesToShow: 5,
            vertical: false,
            slidesToScroll: 1,
            asNavFor: '.ProductDetailImages ul',
            focusOnSelect: true
            //centerMode: false
        });


        $ItemIndex = $('.ProductDetailImages ul li.slick-current').data("slick-index");
        $(".SmallProductImages img").each(function (x) {
            var Item = $(this)
            if (Item.index() == $ItemIndex) {
                Item.addClass("Selected");
            }
        });
        $(".SmallProductImages").hide();
    }

    if ($(".PdIcons > div").length <= 0) $(".PdIcons").hide();

}




$(document).ready(function () {


    $miniImage = $(".SmallProductImages");

    //RunSlickSlider();
    
    //$slc.slick("slickGoTo", $("#ImageAngle").val() - 1, true);
    //$miniImage.slick("slickGoTo", $("#ImageAngle").val() - 1, true);

    //$(".ProductName > .SizeTableLink").on("click", function () {

    //    $("#SizeTableModal").modal();
    //    var ProductID = $(this).closest(".ProductName").next(".CombineColors").find(".ProductID").val();
    //    var ColorID = $(this).closest(".ProductName").next(".CombineColors").find(".ColorID").val();

    //    $.ajax({
    //        type: "GET",
    //        url: "/" + $("#SmallLangCode").val() + "/p/ProductDetails/SizeChart?ProductID=" + ProductID + "&ColorID=" + ColorID,
    //        success: function (data) {

    //            $(".SizeTableDiv").html(data);

    //        }
    //    });


    //});
    
    //$(".combineDecription").on("click", function () {

    //    $(this).next().slideToggle();
    //    $(this).find(".ToggleIcon").toggleClass("AcIcon");
    //    $(this).find(".ToggleIcon").toggleClass("KapaIcon");

    //});
    
    //SEPETE EKLE TEK TEK
    $(".AddCombineItemToBasket").on("click", function (e) {

        // $(".AddToBasket button").append("<i class='BasketsIcon hidden-xs hidden-sm'></i>");

        var SizeID = $(this).parent().parent().parent().find(".CombineColors .SizeID").val();
        var ColorID = $(this).parent().parent().parent().find(".CombineColors .ColorID").val();
        var ProductID = $(this).parent().parent().parent().find(".CombineColors .ProductID").val();
        var Amount = "1";
        var LangID = $("#LangID").val();
        var BedenSec = $('#BedenSec').val();
        var RenkSec = $('#RenkSec').val();
        var UrunYok = $('#UrunYok').val();

        $basketButton = $(this);

        if (SizeID != undefined && ColorID != undefined && ProductID != undefined && SizeID != "" && ColorID != "" && ProductID != "") {

            var NormalText = $basketButton.attr("title");
            var AddingText = "Ekleniyor...";
            $basketButton.find("span").html(AddingText);

            $.ajax({
                type: 'get',
                url: "/" + $("#SmallLangCode").val() + "/p/Cart/AddToCart",
                data: 'sizeID=' + SizeID + "&colorID=" + ColorID + "&productID=" + ProductID + "&adet=" + Amount + "&langID=" + LangID,
                dataType: 'json',
                async: true,
                success: function (dt) {
                    $basketButton.html("<span>" + NormalText + "</span>");

                    $basketButton.addClass("BasketActive");

                    //alert(NormalText);

                    $("#GeneralModal .modal-header h3").html(dt.IslemSonucAciklama);

                    if (dt.Sonuc == true) {

                        $Modal = $("div#QuickLookModal");

                        if ($Modal.length > 0) {
                            $Modal.modal("hide");
                        }

                        $.ajax({
                            type: 'get',
                            url: "/" + $("#SmallLangCode").val() + "/p/Cart/GetSepetIcerik",
                            data: "",
                            async: true,
                            contentType: "application/json; charset=utf-8",
                            dataType: 'text',
                            success: function (dt) {
                                $("#UserMenus > #UserAndBasket").html(dt);

                                $('html, body').animate({ scrollTop: 0 }, 'slow');

                                $(".RightBasket").addClass("active");
                                $("body").addClass("BackDropped");

                                $(".SepetProducts").hide();
                                $(".SepetProducts").addClass("activeBasket");

                            }
                        });

                        if (typeof UseSwStat != 'undefined' && UseSwStat == true) {

                            var basketParams = GetSwPageParams();

                            basketParams = ChangeSwHashedStringParamValue(basketParams, "ActionType", "SepeteEkleme");
                            basketParams = ChangeSwHashedStringParamValue(basketParams, "ProductID", ProductID);
                            basketParams = ChangeSwHashedStringParamValue(basketParams, "ColorID", ColorID);
                            basketParams += "&CatalogID=" + $("#CurCatalogID").val();

                            AddSwAction(basketParams);

                        }

                        if (UseTagManager) {

                            SendCartAddEvent('');
                        }


                    }
                    else {

                        alert(dt.IslemSonucAciklama);
                    }


                }
            });




        }
        else {

            if (SizeID == undefined || SizeID == "") {


                if ($(".NewPD").length <= 0) {

                    alert(BedenSec);

                } else {

                    $("#PrdBlackBg").show();
                    $basketButton.parent().parent().parent().find(".CombineSizes .CombineSizeOptions.open").addClass("PleaseSelect");
                    $basketButton.parent().parent().parent().find(".CombineSizes .CombineSizeOptions.open").addClass("singleSelect");

                }

                if ($(".NewPD").length > 0 && $(".AutoTextRep").length > 0) {

                    $(".AddCombineToBasket button").attr("data-first", $(".AddCombineToBasket button").text());
                    $(".AddCombineToBasket button").text($('#BedenSec').val());
                }

            }

            if (ColorID == undefined || ColorID == "") {

                alert(RenkSec);

                $(".AddCombineToBasket button").attr("data-first", $(".AddCombineToBasket button").text());

                if ($(".NewPD").length > 0 && $(".AutoTextRep").length > 0) {
                    $(".AddCombineToBasket button").text($('#BedenSec').val());
                }

            }

            if (ProductID == undefined || ProductID == "") alert(UrunYok);


        }

        e.preventDefault();
        return false;

    });

    //SEPETE EKLE TÜMÜ
    $(".AddCombineToBasket #Basket").on("click",function () {
        console.log("1");
        var SizeError = "";
        var ColorError = "";

        var Amount = $(".CombineAmountOptions #Amount").val();

        var LangID = $("#LangID").val();

        var BedenSec = $('#BedenSec').val();
        var RenkSec = $('#RenkSec').val();
        var UrunYok = $('#UrunYok').val();
        var ItemOnly = $(this).hasClass("AddCombineItemToBasket");
        $basketButton = $(this);

        $Inputs = $(".CombineColors input");

        if (ItemOnly) {
            console.log("2");
            $(".AddPleaseSelect").removeClass("PleaseSelect AddPleaseSelect");
            $Inputs = $(this).closest(".ProductName").next(".CombineColors").find("input");
        }

        $Inputs.each(function (index) {
            console.log("3");
            if ($(this).hasClass("SizeID")) {
                var sizeIDValue = $(this).val();

                if ($("a.SizeLink.active").length <= 0) {

                    SizeError = BedenSec;
                    $(this).closest(".CombineColors").next().addClass("AddPleaseSelect");
                    $(".PrdBlackBg").css("display", "block");
                }

                if ((sizeIDValue == undefined || sizeIDValue == "") && $(this).closest(".CombineColors").next().find("a.SizeLink").length > 0) {

                    //SizeError = BedenSec; 
                    // $(this).closest(".CombineColors").next().addClass("AddPleaseSelect");
                }
            }

            if ($(this).hasClass("ColorID")) {
                console.log("4");
                var colorIDValue = $(this).val();

                if (colorIDValue == undefined || colorIDValue == "") {
                    ColorError = RenkSec;
                }

            }

        });

        if (SizeError == "" && ColorError == "") // SizeID != undefined && ColorID != undefined && ProductID != undefined && SizeID != "" && ColorID != "" && ProductID != ""
        {
            var NormalText = $basketButton.text();
            var AddingText = $basketButton.attr("data-adding");
            console.log("5");
            $basketButton.text(AddingText);

            $.ajax({
                type: 'get',
                url: "/" + $("#SmallLangCode").val() + "/p/Cart/AddCombineToCart",
                data: $("#ProductCombineContent").find("input").serialize() + "&adet=" + Amount + "&langID=" + LangID,
                dataType: 'json',
                async: true,
                success: function (dt) {

                    $basketButton.text(NormalText);

                    //alert(dt.Sonuc + dt.IslemSonucAciklama);
                    console.log("6");
                    $("#GeneralModal .modal-header h3").html(dt.IslemSonucAciklama);

                    if (dt.Sonuc == true) {

                        $.ajax({
                            type: 'get',
                            url: "/" + $("#SmallLangCode").val() + "/p/Cart/GetSepetIcerik",
                            data: "",
                            async: true,
                            contentType: "application/json; charset=utf-8",
                            dataType: 'text',
                            success: function (dt) {

                                $("#UserAndBasket").html(dt);

                                $('html, body').animate({ scrollTop: 0 }, 'slow');

                                $(".RightBasket").addClass("active");
                                $("body").addClass("BackDropped");
                                setContentHeight();
                                //$(".SepetProducts").hide();
                                //$(".SepetProducts").addClass("activeBasket");

                            }
                        });

                    }
                    else {

                        alert(dt.IslemSonucAciklama);
                    }



                }
            });



        }
        else {

            if (SizeError != "") {

                if ($(".NewPD").length <= 0) {

                    alert(BedenSec);

                } else {

                    $("#PrdBlackBg").show();

                    $(".AddPleaseSelect .CombineSizeOptions.open").addClass("PleaseSelect");

                }

                if ($(".NewPD").length > 0 && $(".AutoTextRep").length > 0) {

                    $(".AddCombineToBasket button").attr("data-first", $(".AddCombineToBasket button").text());
                    $(".AddCombineToBasket button").text($('#BedenSec').val());
                }

            }

            if (ColorError != "") {

                alert(RenkSec);

                $(".AddCombineToBasket button").attr("data-first", $(".AddCombineToBasket button").text());

                if ($(".NewPD").length > 0 && $(".AutoTextRep").length > 0) {
                    $(".AddCombineToBasket button").text($('#BedenSec').val());
                }
            }

        }

    });

    //Combine Size Selection
    $('.CombineSizeOptions a').on("click", function () {


        $combineSizes = $(this).parents(".CombineSizes");
        $combineColors = $combineSizes.prev();

        if ($(this).hasClass("active")) {

            $combineSizes.find(".Name").html("");
            $combineColors.find(".SizeID").val("");
            $(this).removeClass("active");

            CalculateCombinePrice();

        }
        else {

            $combineSizes.find(".Name").html($(this).attr("data-name"));
            $combineColors.find(".SizeID").val($(this).attr("data-id"));

            $(this).parent().find("a").removeClass("active");
            $(this).addClass("active");


            if ($(".NewPD").length > 0) {

                $combineSizes.find(".CombineSizeOptions").addClass("passed");

                $(".CombineSizeAndAmount span.ChooseTitle ").addClass("passed");

                $combineColors.find("span.ChooseTitle").removeClass("current");
                $combineColors.find("span.ChooseTitle").addClass("passed");

                $combineSizes.find("span.ChooseTitle").removeClass("current");
                $combineSizes.find("span.ChooseTitle").addClass("passed");

                $(".SizeAndAmount  > span.ChooseTitle").removeClass("current");
                $(".SizeAndAmount  > span.ChooseTitle").addClass("passed");

                $(".AmountOptions  span.ChooseTitle").removeClass("passed");
                $(".AmountOptions  span.ChooseTitle").addClass("current");

                $(".AmountOptions").addClass("open");

                var isAllSizesSelected = true;
                var SelectedSizeCount = $("a.SizeLink.active").length;

                $(".CombineSelected").html(SelectedSizeCount);

                var TrigAddBasket = false;

                if ($(".CombineSizeOptions.PleaseSelect").length == 1) {
                    TrigAddBasket = true;
                }

                if ($(".AutoTextRep").length > 0) {

                    CalculateCombinePrice();

                    if (isAllSizesSelected) {

                        $(".AddCombineToBasket button").removeClass("NotSelected");
                        $(".AddCombineToBasket button").text($(".AddCombineToBasket button").attr("data-first"));
                        $(".CombineSizeOptions").removeClass("PleaseSelect");
                        $("#PrdBlackBg").hide();

                        if (TrigAddBasket) {
                            $(".AddCombineToBasket #Basket").click();
                        }
                    }

                }


            }


        }

    });

    $('.ProductDetail .CombineColors a').on("click", function () {

        $combineColors = $(this).closest(".CombineColors");
        $combineSizes = $combineColors.next(".CombineSizes").first();

        $combineItemRow = $(this).closest(".CombineItemRow");
        $('#RemindModal .modal-body .alert-error').hide();
        $('#RemindModal .modal-body .remind-success').hide();
        $('.RemindInfo').show();

        $combineColors.find(".Name").html($(this).attr("data-name"));
        $combineColors.find(".ColorID").val($(this).attr("data-id"));
        $combineColors.find(".SizeID").val("");

        var ProductID = $combineColors.find(".ProductID").val();

        $(this).parent().find("a").removeClass("active");
        $(this).addClass("active");

        $combineColors.find(".SizeID").val("");

        $(".AjaxLoader").show();

        var params = "ColorID=" + $(this).attr("data-id") + "&ProductID=" + ProductID;

        var lastColorID = 0;

        $("a.NotifyWhen").live("click", function myfunction() {

            $("#NotifyModal").modal("show");
            var ColorID = $(this).closest(".CombineItemRow").find(".ColorID").val();
            var SizeID = $(this).closest(".CombineItemRow").find(".SizeID").val();
            var ProductID = $(this).closest(".CombineItemRow").find(".ProductID").val();

            $.ajax({
                type: "GET",
                url: "/" + $("#SmallLangCode").val() + "/p/ProductDetails/GetListForRemind?ProductID=" + ProductID,
                cache: true,
                success: function (data) {

                    $("#NotifyModal .modal-body").html(data);
                    $(".NotifyColors a:first").trigger("click");
                }
            });


        });
 

        if (lastColorID != $(this).attr("data-id")) {

            lastColorID = $(this).attr("data-id");

            if ($(".ProductHeader #ProductID").length > 0) {

                var newhash = "#C=" + $(this).attr("data-id");
                window.location.hash = newhash;
            }




            $.ajax({
                type: "GET",
                url: "/" + $("#SmallLangCode").val() + "/p/ProductDetails/GetAllDetailInfoByColorID",
                data: params,
                success: function (data) {

                    $selectSizePopup = $(".CombineSizeOptions .SelectSizePopup:first");

                    if ($selectSizePopup.length > 0) {

                        $selectSizePopup = $(".CombineSizeOptions .SelectSizePopup").clone();
                    }

                    $combineSizes.find(".CombineSizeOptions").html("");

                    if ($selectSizePopup.length > 0) {
                        $combineSizes.find(".CombineSizeOptions").append($selectSizePopup);
                    }

                    var imgCount = 0;

                    var ImageCount = data.filter(function (val) {
                        return val.Type === "StockImage";
                    });

                    console.log(ImageCount);

                    if (ImageCount.length > 0) {
                        $(".SmallProductImages img").remove();
                        $('.ProductDetailImages ul li.ImgArea').remove();
                        $('.ProductDetailImages ul li.ImgArea').html("");
                        $(".SmallProductImages").html("");
                    }

                 


                    for (var i = 0; i < data.length; i++) {
                        if (data[i].Type == "Size") {
                            var stil = "";
                            if (data[i].InStock == false || data[i].PStatus != 1) {

                                stil = "OutOfQuantity";

                                //if ($(".NewPD").length > 0) {

                                //    $combineSizes.find(".CombineSizeOptions").append('<span class=\"outer\">' +
                                //        '  <div class="PdHint"> <div class="PdHint-content">Bu Ürünün ' + data[i].Name + ' Bedeni Stoklarla Kalmamıştır.<br />' +
                                //            '<a href="#" class="NotifyWhen">Ürün stoğa geldiğinde haber ver!</a>' +
                                //       ' </div></div>'
                                //        + '<span class=\"inner\">' + data[i].Name + '</span></span>');

                                //} else {
                                //    $combineSizes.find(".CombineSizeOptions").append('<span class=\"outer\"><span class=\"inner\">' + data[i].Name + '</span></span>');

                                //}

                                $('.AddToRemindList').show();

                            }

                            else {
                                $combineSizes.find(".CombineSizeOptions").append('<a data-id="' + data[i].ID + '" data-stock="' + data[i].InStock + '" data-name="' + data[i].Name + '" href="javascript:void(0)" class="SizeLink ' + stil + " " + data[i].Name + '">' + data[i].Name + '</a>');
                            }
                            $(".AjaxLoader").hide();

                        }



                        if (data[i].Type == "StockImage") {

                            $imgKucuk = $('<img >');
                            $imgKucuk.attr('src', data[i].Name.replace("_buyuk", "_kucuk"));
                            $combineItemRow.find(".CombineItemImg img").remove();

                            if ($combineItemRow.find(".CombineItemImg img").attr("src") != data[i].Name.replace("_buyuk", "_kucuk")) {
                                $combineItemRow.find(".CombineItemImg").append($imgKucuk);
                                $imgKucuk.show("slow");
                            }

                            $(".SmallProductImages").prepend($imgKucuk.clone());


                            if (imgCount == 0) {
                                //$(".CombineItemImg img:first", $combineItemRow).trigger("click");
                            }

                            var srcAttr = "src";

                            if (imgCount == 0) {
                                //srcAttr = "data-src";
                            }

                            var $img = $('<img >');
                            $img.attr(srcAttr, data[i].Name.replace("_buyuk", "_detay"));

                            var $li = $('<li class="ImgArea">');

                            if (imgCount >= 1) {
                                $li.addClass("gizli");
                            }

                            //var $a = $('<a>');
                            //$a.attr('href', data[i].Name);
                            //$a.attr('class', "cloudzoomManuel cloud-zoom");

                            //$a.append();
                            $li.append($img);

                            $li.prependTo('.ProductDetailImages ul');
                            // $li.clone().prependTo($newul);

                            imgCount++;



                        }


                    }

                    //$miniImage.slick('unslick');
                    //$slc.slick('unslick');
                    //$(".SmallProductImages").slick('unslick');
                    //$(".ProductDetailImages ul").slick('unslick');

                    //RunSlickSlider();

                    // küçük slider resmi ile büyük slider resmi aynı olması için
                    //$("#ProductsImages > .SmallProductImages button.slick-next").trigger("click");


                    //$(".ProductDetailImages ul li").each(function () {
                    //    if ($(this).hasClass("slick-current")) {
                    //        var ClickedItem = $(this);
                    //        $(".SmallProductImages img").remove("Selected");
                    //        $(".SmallProductImages img").each(function () {
                    //            if ($(this).data("slick-index") == ClickedItem.data("slick-index")) {
                    //                $(this).find("img").addClass("Selected");
                    //            }

                    //        });

                    //    }

                    //});

                    if ($(".NewPD").length > 0) {

                        $combineSizes.find(".CombineSizeOptions, .SizeAndAmount span.ChooseTitle").addClass("open");

                        $combineSizes.find(".CombineColors span.ChooseTitle").removeClass("current");
                        $combineColors.find("span.ChooseTitle").addClass("passed");

                        $combineSizes.find(".CombineSizeAndAmount span.ChooseTitle").addClass("current");
                        $combineSizes.find(".CombineSizeAndAmount span.ChooseTitle").removeClass("passed");

                        $combineSizes.find(".Name").html("");

                        $(".AddToBasket button").addClass("NotSelected");

                        if ($(".AddToBasket button").attr("data-first") != undefined && $(".AddToBasket button").attr("data-first").length > 0) {
                            $(".AddToBasket button").text($(".AddToBasket button").attr("data-first"));
                        }

                    }

                },
                error: function () {

                    alert('Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.!');
                }

            });




        }

        CalculateCombinePrice();

    });

    //ürün küçük resmine tıklandığında sol büyük galeride görüntüler.
    //$(".CombineItemImg img").on("click", function () {

    //    $(this).parent().parent().find("a.active").trigger("click");
    //    //$(this).parent().parent().find("a.active").trigger("click");
    //    ////alert$(".ProductDetailImages ul img.sagOk").length);

    //});

    $(document).on("click",".CombineDetails .SmallProductImages  img", function () {
        $(".CombineDetails .SmallProductImages  img").removeClass("Selected");
        $(this).addClass("Selected");
        var thatIndex = $(this).index();
        console.log(thatIndex);
        $(".ProductDetailImages ul li").addClass("gizli");

        $(".CombineDetails .ProductDetailImages ul li").each(function () {

            if (thatIndex == $(this).index()) {
                $(this).removeClass("gizli");
            }
        });
    });



    //$('.ProductDetailImages ul').on('afterChange', function (event, slick, currentSlide, nextSlide) {
    //    // alert("change");
    //    $(".SmallProductImages").slick("slickGoTo", currentSlide);
    //    //alert("Slide --> " + currentSlide);

    //    $(".SmallProductImages img").each(function () {

    //        //$(this).addClass("slick-current");

    //        if ($(this).hasClass("slick-current")) {
    //            $(this).addClass("Selected");

    //            //alert($(this).index());
    //        }
    //        else {
    //            $(this).removeClass("Selected");
    //        }

    //    });


    //});


    //ilk küçük resime tıklamayı tetikliyoruz. (küçük slider için)
    //$("#ProductCombineContent > .CombineItemRow > .CombineItemImg:first img").parent().parent().find("a.active").trigger("click");

});

//jQuery(window).load(function () {
//    $("#ProductsImages > .SmallProductImages button.slick-next").trigger("click");
//});